/**
 * Parse an ISO 8601 date string into a Date object
 *
 * If the time is not relevant, ensures the resulting Date starts at midnight local time, without
 * timezone conversion.
 *
 * @param {string} dateString The ISO 8601 date string to parse
 * @param {boolean} dateOnly Whether the time component of the date is relevant
 * @returns {Date|null} The parsed Date object, or null if the input is invalid
 */
export const parseLocalDate = (dateString, dateOnly) => {
  if (!dateString) return null;

  let stringToParse = dateString;
  // Ensure date-only (either a string without a time, or when forced) is parsed at midnight local time
  if (dateOnly || !stringToParse.includes("T")) {
    stringToParse = `${stringToParse.split("T")[0]}T00:00:00`;
  }

  const parsedDate = new Date(stringToParse);

  // Date.js overrides the Date constructor to always return a valid date object,
  // which has valueOf() === 0 if it couldn't parse the input, so we need to check for both.
  // isNaN() normally returns true for an invalid Date.
  if (isNaN(parsedDate) || parsedDate.valueOf() === 0) {
    return null;
  }
  return parsedDate;
};
